/**
 * The paths, plus a way for the store to navigate.
 *
 * This module imports nothing on purpose. The store needs to move the user
 * between screens (a scan resolves, a draft is saved), but store actions run
 * outside React and cannot call useNavigate. Importing the route tree instead
 * would cycle — routes pull in screens, screens pull in the store — so the
 * router hands its navigate function down here once and the store calls it.
 */

/** German paths, matching what the panel calls these screens on the rail. */
export const PATHS = {
  /** The dashboard is the landing screen — that is what a dashboard is for. */
  dash: '/',
  inhalt: '/inhalt',
  scan: '/scannen',
  confirm: '/scannen/pruefen',
  cal: '/kalender',
  shop: '/einkauf',
  notes: '/notizen',
  settings: '/system',
  setup: '/einrichtung',
} as const;

export type ScreenKey = keyof typeof PATHS;

type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

let navigate: NavigateFn | null = null;

/** Called once by the router bridge, on mount. */
export function setNavigator(fn: NavigateFn | null): void {
  navigate = fn;
}

/**
 * Navigate from outside React.
 *
 * A no-op before the router mounts, which is the correct behaviour: nothing can
 * have navigated yet, and the initial URL already decides the first screen.
 */
export function goTo(screen: ScreenKey, options?: { replace?: boolean }): void {
  navigate?.(PATHS[screen], options);
}
